import React, {Component} from 'react';
import {_createNewBulkProxies} from "../../../../../services/apis/ProxiesServices"
import PropsTypes from "prop-types"
import {Alert} from "reactstrap"

class CreateNewBulkProxies extends Component {

    state = {
        uris: [],
        note: '',
        error: '',
    }

    _handleSubmit = (e) => {
        e.preventDefault();
        const {uris, note} = this.state;
        _createNewBulkProxies(uris, note)
            .then(result => {
                if (result.success) {
                    this.setState({
                        uris: [],
                        note: ''
                    })
                    this.props.onRefreshPage()
                } else {
                    this.setState({
                        error: result.message
                    })
                }

            })

    }


    _handleChangeTextForm = field => e => {
        this.setState({
            error: ''
        })
        const {value} = e.target;
        this.setState({
            [field]: value.split(" ")
        });
    }

    render() {
        const {uris, note, error} = this.state;
        const list = uris.join(" ")

        return (
            <div className="CreateNewEvent col-md-4 col-12">
                {
                    !!error ? <Alert color="danger">{error}</Alert> : ''
                }
                <form onSubmit={this._handleSubmit}>
                    <div className="form-group">
                        <input
                            className='form-control'
                            value={list}
                            placeholder='Proxy'
                            onChange={this._handleChangeTextForm('uris')}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            className='form-control'
                            value={note}
                            placeholder='Note'
                            onChange={this._handleChangeTextForm('note')}
                        />
                    </div>
                    <div className="form-group">
                        <button className="btn btn-success" type='submit'>Create</button>
                    </div>
                </form>
            </div>
        )
    }
}

CreateNewBulkProxies.propsTypes = {
    onRefreshPage: PropsTypes.func.isRequired,
}


export default CreateNewBulkProxies;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/proxies/component/CreateNewBulkProxies.js